import { initPicador } from '@/xhr/connections';
import axiosWrapper from '@/xhr/axiosWrapper';

/**
 * Export basic methods
 */
export default {
  ...axiosWrapper(initPicador),
};
